export default __webpack_public_path__ + "static/media/I-3.93f06c07.png";